/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Creation_DescriptionInputs */



/**
* | output |
* | --- |
* | "When set to admins, only administrators can create new agents." |
*
* @param {Agent_Policy_Creation_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_creation_description = /** @type {((inputs?: Agent_Policy_Creation_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Creation_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei „Nur Admins“ können nur Administratoren neue Agenten erstellen.")
	return /** @type {LocalizedString} */ ("When set to admins, only administrators can create new agents.")
});